import { css } from 'styled-components';

export const chatBackground = css`
  background: ${({ theme }) => theme.palette.surface.soft};
`;
